import React from 'react'
import { Row } from 'react-angle-dashboard-components'
import { PlanCardLabel, PlanCardValue } from './style'

const InfoRow = ({
  label,
  value
}: {
  label: string
  value: string | number
}) => {
  return (
    <Row className="d-flex justify-content-between">
      <PlanCardLabel>{label}</PlanCardLabel>
      <PlanCardValue>{value}</PlanCardValue>
    </Row>
  )
}

export default InfoRow
